import React from 'react'
import { ResponsiveSVG } from 'ui/acro'
import { Logged } from 'images/latest'

const LoggedIcon = ({ color = 'white', width = '30px', height = '30px' }) => (
  <ResponsiveSVG
    width={width}
    height={height}
    className='unstyled'
    fill={color}
    SVG={Logged}
    svgProps={{ fill: color }}
  />
)

export default LoggedIcon
